<!-- 外部系统对接设置  --- 外部系统对接设置明细 -- 外部系统对接设置明细详情-->
<template>
  <div class="tableShow">
    <Table
       ref="table"
      :loadObj='{}'
      :option="{}"
      :colObj='{
        opId:"3179",
        name:"外部系统对接设置明细详情",
        parentId:"DATA_ID",
        parentName:"外部系统对接设置明细",
        parentPath:"/system/interfaceSetupSon",
        parentQuery:{
        },
        addForm:{
        },
        dataClass:21,
        col:[]
      }'
    >
    </Table>
  </div>
</template>

<script>
import Table from "@/components/table/dataTablecSon";
export default {
  components: {
    Table,
  },
  data() {
    return {
        firstEnter:true
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  activated() {
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  },
};
</script>

<style></style>